import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../../components/Grid';
import Moment from 'moment';
import { extendMoment } from 'moment-range';

function removeClosedLifts(allLifts) {
  // Filter out lifts that are either closed or not yet open
  let openLifts = allLifts.filter((lift) => {
    if (lift.open_today !== null) {
      const openTodayArray = lift.open_today.split('-');

      const moment = extendMoment(Moment);
      const API_DATE_FORMAT = 'hh:mm';
      const UTC_DATE_FORMAT = 'HHmm[Z]';

      const today = new Date();
      const endTimeUtc = moment(openTodayArray[1], API_DATE_FORMAT).format(
        UTC_DATE_FORMAT
      );
      const timeNowUtc = moment(
        today.getHours() + ':' + today.getMinutes(),
        API_DATE_FORMAT
      ).format(UTC_DATE_FORMAT);

      return timeNowUtc <= endTimeUtc;
    }
  });
  return openLifts;
}

const LiftsToday = (props) => {
  let lifts = null;
  let openLifts = null;

  if (props.lifts && props.lifts.length > 0) {
    const liftData = props.lifts;
    openLifts = removeClosedLifts(liftData);

    lifts = openLifts.map((lift) => {
      return {
        content: (
          <Grid
            className="content"
            columns={[
              <div key="name" className="lift-content__container">
                <p className={`icon lift-type-${lift.class}`}>{lift.name}</p>
                <p key="status" className="status">
                  {lift.open_today}
                </p>
              </div>,
            ]}
          />
        ),
      };
    });
  }

  return (
    <div className="lifts">
      <h3>
        {Drupal.t('Open lifts: ', {}, { context: 'count' })}
        {openLifts.length + '/' + props.lifts.length}
      </h3>
      <ul className="today-page__list lift-list">
        {lifts && lifts.length > 0 ? (
          lifts.map((lift, i) => (
            <li key={i} className="today-page-list__item">
              <div className="list__content">{lift.content}</div>
            </li>
          ))
        ) : (
          <h3>{Drupal.t('Lifts info not available.')}</h3>
        )}
      </ul>
    </div>
  );
};

LiftsToday.propTypes = {
  lifts: PropTypes.array,
};

export default LiftsToday;
